import useSWR from 'swr';


const repoFetcher = async (url) => {
    var ret = [];
    const rsp = await fetch(url);
    if (!rsp.ok) {
        var error = new Error("Failed to fetch");
        error.status = rsp.status;
        error.info = await rsp.text();
        throw error;
       }
    if (rsp.ok) {
        ret = await rsp.json();
        }
    return ret;
    }

const useRepos = (owner) => {
    return useSWR(`/api/repos/${owner}`, repoFetcher);
    }

export default useRepos;